import React from "react";
import {css} from "@panda/css";

import {googlePlacesDivId} from "../../../search/utils/search_constants";
import {HomepageLegacyDesktopSearch} from "./HomepageLegacyDesktopSearch";
import {HomepageLegacyMobileSearch} from "./HomepageLegacyMobileSearch";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacySearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacySectionHolderStyle}>
            <div id={googlePlacesDivId} />
            <HomepageLegacyDesktopSearch {...props} />
            <HomepageLegacyMobileSearch {...props} />
        </div>
    );
};

const legacySectionHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",

    "& > div:not(#google_places_tab_results)": {
        width: "100%",
        alignSelf: "center",
        maxWidth: "552px"
    }
});
import React from "react";
import {css} from "@panda/css";

import {googlePlacesDivId} from "../../../search/utils/search_constants";
import {HomepageLegacyDesktopSearch} from "./HomepageLegacyDesktopSearch";
import {HomepageLegacyMobileSearch} from "./HomepageLegacyMobileSearch";
import {IHomepageSearchViewProps} from "./HomepageSearchTypes";

export const HomepageLegacySearch = (props: IHomepageSearchViewProps) => {
    return (
        <div className={legacySectionHolderStyle}>
            <div id={googlePlacesDivId} />
            <HomepageLegacyDesktopSearch {...props} />
            <HomepageLegacyMobileSearch {...props} />
        </div>
    );
};

const legacySectionHolderStyle = css({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",

    "& > div:not(#google_places_tab_results)": {
        width: "100%",
        alignSelf: "center",
        maxWidth: "552px"
    }
});
